import React, { useEffect, useRef, useState } from 'react';

import {Platform, View} from 'react-native';
import Loader from '../../Loader/loader';
import WebView from 'react-native-webview';
import { getCleanUrl } from '../../../utils/Helper';
import { useCssStyle } from '../../../customHook/getCssStyle';
import { handleMessageEventListener } from '../../../js/eventListener';
import { useNavigation } from '@react-navigation/native';
import { useDispatch } from 'react-redux';

const IFrameRendererHome_Potrait = (props) => {
  const {handleOnWidgetClick, listItemData, widget} = props;

  const getStyles = useCssStyle();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const webViewRef = useRef();
  const iframeRef = useRef();

  const navigate = useNavigation();

  const [contentHeight, setContentHeight] = useState();

  useEffect(() => {
    if (Platform.OS === 'web') {
      const handleMessage = (event) => {
        dispatch(handleMessageEventListener(event, iframeRef, navigate));

        try {
          const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

         if (data && data.type == 'HEIGHT') {
            setContentHeight(prev => ({[listItemData[0]?.widgetId]: data?.height}));
          }
        } catch (e) {
        }
      };

      window.addEventListener('message', handleMessage);
      setTimeout(() => {
        setLoading(false);
      }, 900);
      
      return () => window.removeEventListener('message', handleMessage);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listItemData[0]?.widgetId]);
  

  if (!listItemData?.length) {
    return null;
  } 

  return (
    <View
      style={getStyles([
        'iFrameRendererHomeMainContainer',
        `iFrameRendererHomeMainContainer_${listItemData[0].widgetMetaHtmlId}`,
        `iFrameRendererHomeMainContainer_${listItemData[0].widgetId}`,
      ])}

      id={`iFrameRendererHomeMainContainer iFrameRendererHomeMainContainer_${listItemData[0].widgetMetaHtmlId} iFrameRendererHomeMainContainer_${listItemData[0].widgetId}`}>
      <View
        style={getStyles(['widgetmainContainer', 'iFrameMainContainer'])}
        id="widgetmainContainer iFrameMainContainer">
        {loading && (
          <View
            style={{
              height: '100%',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Loader style={getStyles(['crossOverContaniner_loader'])} />
          </View>
        )}
        {listItemData?.length && listItemData.map((widgetData, index) => {
            const url = getCleanUrl(widgetData?.targetUrl);
            
            return Platform.OS === 'web' ? (
                <iframe
                    ref={iframeRef}
                    src={url}
                    style={getStyles([
                      'widgetmainContainerChildContainer',
                      'iFrameRendererHomeMainContainerChildContainer',
                      `iFrameRendererHome_${widgetData?.widgetMetaHtmlId}`,
                      {overflow: "hidden"}
                    ])}
                    
                    title={widgetData?.displayName}
                    scrolling="no"
                    onLoad={() => {
                      setLoading(false);

                      try {
                        const iframe = iframeRef.current;
                        if (!iframe) return;

                        const doc = iframe.contentDocument || iframe.contentWindow.document;

                        doc.body.style.overflow = "hidden";
                        doc.documentElement.style.overflow = "hidden";
                      } catch (err) {
                        console.warn("Cannot modify iframe contents due to CORS:", err);
                      }
                    }}
                    id={`widgetmainContainerChildContainer iFrameRendererHomeMainContainerChildContainer iFrameRendererHome_${widgetData?.widgetMetaHtmlId}`}
                />
                ) : (
                <WebView
                    ref={webViewRef}
                    originWhitelist={['*']}
                    style={getStyles([
                      'widgetmainContainerChildContainer',
                      'webViewHomeMainContainerChildContainer',
                      `webViewHome_${widgetData?.widgetMetaHtmlId}`,
                    ])}
                    source={{uri: url}}
                    javaScriptEnabled={true}
                    cacheEnabled={true}
                    scrollEnabled={false}
                    injectedJavaScript={`
                      (function() {
                        const originalPostMessage = window.postMessage;
                        window.postMessage = function(message, targetOrigin) {
                          if (window.ReactNativeWebView) {
                            const dataToSend = typeof message === 'string' ? message : JSON.stringify(message);
                            window.ReactNativeWebView.postMessage(dataToSend);
                          }
                          originalPostMessage.call(window, message, targetOrigin);
                        };

                        window.addEventListener('message', function(event) {
                          if (window.ReactNativeWebView) {
                            const dataToSend = typeof event.data === 'string' ? event.data : JSON.stringify(event.data);
                            window.ReactNativeWebView.postMessage(dataToSend);
                          }
                        });
                      })();
                      true; 
                    `}

                    onLoad={() => {
                      setLoading(false);
                    }}
                    onMessage={(event)=> {
                      dispatch(handleMessageEventListener(event, webViewRef, navigate));
                      try {
                        const data = JSON.parse(event.nativeEvent.data);
                        if (data && data.type === 'HEIGHT' && data.height) {
                          setContentHeight(prev => ({[listItemData[0]?.widgetId]: data?.height}));
                        }
                      } catch (e) {
                      }
                    }}
                />
            )
        })}
      </View>
    </View>
  );
};

export default IFrameRendererHome_Potrait;
